import styled from "styled-components";

export const BlueBox = styled.div`
    display: block;
    width: 100%;
    height: 21px;
    background-color: #36a2d8;
`